export const REGULATION_TYPE = {
  main: 'DEFAULT',
  recurring: 'RECURRING'
}
